/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AWS from 'aws-sdk';
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import axios from 'axios';
import PortalAuth from '../../utils/Auth';
import { getLogo, getTitle } from '../../brand';
import { fetchUserProfile, updateUserProfile } from './redux/actions';
import { getBackendBaseUrl, fetchBackendUrl } from '../../constants';
import Loading from '../../components/loading';
import styles from './authentication.module.scss';
import ForceChangePasswordForm from './components/ForceChangePasswordForm';
import MailLoginForm from './components/MailLoginForm';
import MailPasswordForm from './components/MailPasswordForm';

function MailLogin({ match, history, actionFetchUserProfile, storeUserProfile }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [blurredFields, setBlurredFields] = useState({});
  const [errors, setErrors] = useState({
    emailEmpty: true,
    verificationCodeEmpty: false,
    newPasswordEmpty: true,
    confirmPasswordEmpty: true,
    passwordEmpty: true,
    invalidCredentials: false,
    invalidPassword: false,
    emailInvalid: false,
    LimitExcced: false,
    verificationInvalid: false
  });
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [cognitoCodeError, setCognitoCodeError] = useState(false);
  const [cognitoPhoneError, setCognitoPhoneError] = useState(false);
  const [currentPage, setCurrentPage] = useState('mailLogin');
  const [isSSO, setIsSSO] = useState('');
  const [cognitoUser, setCognitoUser] = useState(null);

  useEffect(() => {
    if (PortalAuth.getInstance().isAuthenticated()) {
      handlePath();
    }
  }, []);

  const handleInputChange = (inputType, value) => {
    if (value !== '' && cognitoPhoneError === true) {
      setCognitoPhoneError(false);
    } else if (value !== '' && cognitoCodeError === true) {
      setCognitoCodeError(false);
    }
    if (inputType === 'email') {
      setEmail(value);
    } else if (inputType === 'password') {
      setPassword(value);
    }
    validateFormFields(inputType, value);
  };

  const handleNewPasswordRequired = () => {
    setLoadingStatus(false);
    setCurrentPage('forceChangePassword');
  };


  const validateFormFields = (inputType, value) => {
    let errors = {};
    let emailValid;
    switch (inputType) {
      case 'email':
        if (value === '') {
          errors = Object.assign(errors, {
            emailEmpty: true,
            emailInvalid: false,
            emailMobileDeviceLogin: false
          });
        } else if (value?.startsWith('airport+') && value?.endsWith('@aerosimple.com')
            && value?.indexOf('+') !== value?.lastIndexOf('+')) {
              errors = Object.assign(errors, {
                emailEmpty: false,
                emailMobileDeviceLogin: true
              });
        } else {
          emailValid = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(value);
          errors = Object.assign(errors, {
            emailEmpty: false,
            emailInvalid: !emailValid
          });
        }
        break;
      case 'password':
        errors = Object.assign(errors, { passwordEmpty: value === '' });
        break;
      default:
        break;
    }
    setErrors(prev => ({ ...prev, ...errors }));
  };

  const handleAuthError = (error) => {
    console.log('error', error);
    switch (error.code) {
      case 'NotAuthorizedException':
      case 'UserNotFoundException':
        setErrors(prev => Object.assign({}, prev, {
          invalidCredentials: true
        }));
        setLoadingStatus(false);
        break;
      case 'CodeMismatchException':
        setErrors(prev => Object.assign({}, prev, {
          verificationInvalid: true
        }));
        setLoadingStatus(false);
        break;
      case 'LimitExceededException':
        setErrors(prev => Object.assign({}, prev, {
          LimitExceed: true
        }));
        setLoadingStatus(false);
        break;
      case 'InvalidPasswordException':
        setErrors(prev => Object.assign({}, prev, {
          invalidPassword: true
        }));
        setLoadingStatus(false);
        break;
      default:
        break;
    }
  };

  const handleLoginWithOtp = () => {
    history.push('/auth/login');
  };

  const handleInputBlurred = (inputType) => {
    setBlurredFields(prev => (Object.assign({}, prev, {
      [inputType]: true
    })));
  };

  const handleGoBack = () => {
    setCurrentPage('mailLogin');
  };

  const getUserData = (result) => {
    PortalAuth.getInstance().setAuthToken(result.getAccessToken().getJwtToken());
    PortalAuth.getInstance().setIDToken(result.getIdToken().getJwtToken());
    let token = result
      .getIdToken()
      .getJwtToken()
      .split('.')[1];
    token = Buffer.from(token, 'base64').toString();

    // eslint-disable-next-line no-undef
    localStorage.setItem('userId', JSON.parse(token)['cognito:username']);
    fetchBackendUrl()
      .then(() => {
        axios.defaults.baseURL = getBackendBaseUrl();
      })
      .then(() => {
        actionFetchUserProfile();
        handlePath();
        setLoadingStatus(false);
      })
      .catch((err) => {
        setLoadingStatus(false);
        console.log(err);
      });
  };

  const handlePath = () => {
    const { url } = match;
    if (url === '/auth/email/login') {
      history.push('/');
      window.location.reload();
      actionFetchUserProfile();
    }
    window.location.reload();
  };

  const handleMailSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let tempIsSSO = 'password';
    if (errors.emailEmpty || errors.emailInvalid) {
      setBlurredFields(prev => (Object.assign({}, prev, {
        email: true
      })));
      return;
    }
    setLoadingStatus(true);
    const emailDomain = email.split('@')[1];
    const getConfig = () => {
      AWS.config.update({
        region: process.env.REACT_APP_REGION
      });
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
      });
      return AWS.config.credentials.getPromise();
    };
    await getConfig();
    const docClient = new AWS.DynamoDB.DocumentClient();
    const params = {
      TableName: `${process.env.REACT_APP_PREFIX}config`,
      Key: { configKey: 'portal_sso_domains' }
    };
    await docClient.get(params).promise().then((data) => {
      const domains = data?.Item?.configData && Object.values(data?.Item?.configData);
      const allDomains = [];
      for (let i = 0; i < domains?.length; i++) {
        if (domains[i]) {
          allDomains.push(...domains[i]);
        }
      }
      if (allDomains?.indexOf(emailDomain) !== -1) {
        tempIsSSO = '';
      }
    }).catch((err) => { console.log(err, 'errr'); });
    const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();
    const getIdParams = {
      IdpIdentifier: emailDomain,
      UserPoolId: process.env.REACT_APP_USER_POOL_ID
    };
    await cognitoidentityserviceprovider.getIdentityProviderByIdentifier(getIdParams).promise()
      .then((data) => {
        if (data?.IdentityProvider?.IdpIdentifiers?.indexOf(emailDomain) !== -1) {
          tempIsSSO += 'sso';
        }
      }).catch((err) => { console.log('er', err); });
    setLoadingStatus(false);
    setCurrentPage('mailPassword');
    setIsSSO(tempIsSSO || '');
  };

  const handleMailPasswordSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }
    localStorage.setItem('userEmail', email);
    localStorage.setItem('redirectUrl', window.location.href.split('#')[0].replace('/auth/email/login', ''));
    if (e.nativeEvent?.submitter?.attributes?.category?.value === 'sso') {
      window.location.href = `${process.env.REACT_APP_IDP_LOGIN_URL
      }&idp_identifier=${email.split('@')[1]
      }&redirect_uri=${window.location.origin
      }&state=${window.location.pathname.replace('/auth/login', '')}`;
      localStorage.setItem('sso_updated_last_login', true);
      return;
    }
    if (errors.passwordEmpty) {
      setBlurredFields(prev => (Object.assign({}, prev, {
        password: true
      })));
      return;
    }
    setLoadingStatus(true);
    setErrors(prev => Object.assign({}, prev, {
      invalidCredentials: false
    }));

    localStorage.setItem('twoStepVerification', false);
    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: PortalAuth.getInstance().getUserPool()
    });
    setCognitoUser(cognitoUser);
    const authDetails = new AuthenticationDetails({
      Username: email,
      Password: password
    });
    storeUserProfile(cognitoUser);
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: result => getUserData(result),
      onFailure: (err) => {
        handleAuthError(err);
      },
      newPasswordRequired: () => {
        handleNewPasswordRequired();
      }
    });
  };

  let formToRender=(<></>);
  if (currentPage === 'mailLogin') {
    formToRender = (
      <MailLoginForm
        handleInputChange={handleInputChange}
        errors={errors}
        blurredFields={blurredFields}
        handleInputBlurred={handleInputBlurred}
        cognitoCodeError={cognitoCodeError}
        handleLogin={handleMailSubmit}
        email={email}
        handleLoginWithOtp={handleLoginWithOtp}
      />
    );
  } else if (currentPage === 'mailPassword') {
    formToRender = (
      <MailPasswordForm
        handleInputChange={handleInputChange}
        errors={errors}
        blurredFields={blurredFields}
        handleInputBlurred={handleInputBlurred}
        cognitoCodeError={cognitoCodeError}
        handleLogin={handleMailPasswordSubmit}
        password={password}
        email={email}
        handleGoBack={handleGoBack}
        isSSO={isSSO}
      />
    );
  } else if (currentPage === 'forceChangePassword') {
    formToRender = (
      <ForceChangePasswordForm
        cognitoUser={cognitoUser}
      />
    );
  }
  return (
  <div className={styles.authentication}>
    <div className={styles.logo_container} style={{ flexDirection: 'row' }}>
      <img src={getLogo()} alt="logo" style={{ maxWidth: '37px' }} />
      <div className={styles.brand} style={{ fontSize: '37px', letterSpacing: '1px' }}>{getTitle()}</div>
    </div>
    <div className={styles.form_container}>
      {formToRender}
    </div>
    <Loading loadingStatus={loadingStatus} />
  </div>
  );
}

const mapDispatchToProps = dispatch => ({
  actionFetchUserProfile: () => {
    dispatch(fetchUserProfile());
  },
  storeUserProfile: (profile) => {
    dispatch(updateUserProfile(profile));
  }
});

export default connect(null, mapDispatchToProps)(withRouter(MailLogin));
